// the regex must be in this order
export const genderNeutral = (str) =>
  str
    .replaceAll(/female_|male_|Female|Male/gi, '')
    .replaceAll('  ', ' ')
    .trim();
